
import { error } from "@/services/LoggerService";
import { useStore } from "@/store";
import { AuthActionTypes } from "@/store/auth/actions";
import Vue from "vue";

export default Vue.extend({
  name: "ForgotPassword",
  data() {
    return {
      email: "",
      forgettingPassword: "off",
    };
  },
  methods: {
    async forgetPassword() {
      try {
        this.forgettingPassword = "on";
        await this.resetPassword(this.email);
        this.forgettingPassword = "off";
        alert("password reset successfully, check email");
        this.$router.push({ name: "ResetPassword" });
      } catch (e) {
        this.forgettingPassword = "off";
        alert(e);
        error(e);
      }
    },
    async resetPassword(email: string){
      const store = useStore();
      return store.dispatch(AuthActionTypes.ForgetPassword, email);
    }
  },
});
